var $1be8b0ee8841f1e7$exports = {};
$1be8b0ee8841f1e7$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Pr\xf3bnik kolor\xf3w`,
    "colorSwatch": `pr\xf3bka koloru`,
    "transparent": `przezroczysty`,
    "twoDimensionalSlider": `Suwak 2D`
};


export {$1be8b0ee8841f1e7$exports as default};
//# sourceMappingURL=pl-PL.module.js.map
